import React from "react";
import { useRef, useState } from "react";
import { Button, Col, Input, Modal, ModalProps, Panel, Row, Table } from "rsuite";
import Cell from "rsuite/esm/Table/TableCell";
import Column from "rsuite/esm/Table/TableColumn";
import HeaderCell from "rsuite/esm/Table/TableHeaderCell";

interface KeyValueListProps extends ModalProps{
  value: Record<string, string>;
  onChange: (val: Record<string, string>) => void;
};

// Show up to 3 rows below the header, then scroll inside the table.
const MAX_VISIBLE_ROWS = 3;
const TABLE_MAX_HEIGHT = 40 + MAX_VISIBLE_ROWS * 46;

const KeyValueList: React.FC<KeyValueListProps> = ({value, onChange}) => {
    const [selectedKey, setSelectedKey] = useState<string>();
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);

    return (
        <>
            <Panel bordered header='Custom Variables'>
                <Table data={Object.entries(value).map(([key, value]) => ({ key, value }))} autoHeight maxHeight={TABLE_MAX_HEIGHT}>
                    <Column flexGrow={1} align="start" sortable>
                        <HeaderCell>Key</HeaderCell>
                        <Cell dataKey="key" />
                    </Column>
                    <Column flexGrow={4} align="start" sortable>
                        <HeaderCell>Value</HeaderCell>
                        <Cell dataKey="value" />
                    </Column>
                    <Column flexGrow={1} align='center'>
                        <HeaderCell>Actions</HeaderCell>
                        <Cell>
                        {rowData => (
                            <Button 
                            size="xs" 
                            appearance='ghost' 
                            onClick={() => {
                                setEditModalOpen(true);
                                setSelectedKey(rowData.key); 
                                // setVal(rowData.value);
                            }} > Edit </Button>
                        )}
                        </Cell>
                    </Column>                                        
                </Table>
            </Panel>
            {selectedKey && 
                <KeyValueModal 
                    open={editModalOpen}
                    onClose={() => setEditModalOpen(false)}
                    value={value[selectedKey]} 
                    variableKey={selectedKey}
                    onChange={((k, v) => {
                        const updated = {...value};
                        updated[k] = v;
                        onChange(updated);
                    })} 
                />
            }
        </>        
    );
};

export default KeyValueList;


interface KeyValueModalProps extends ModalProps{
  variableKey: string;
  value: string;
  onChange: (key: string, val: string) => void;
};

const KeyValueModal: React.FC<KeyValueModalProps> = ({variableKey, value, onChange, open, onClose}) => {
    const inputRef = useRef<any>(null);

    return(
      <Modal backdrop='static' keyboard={false} open={open} onClose={onClose} onOpen={() => inputRef.current?.focus()}>
        <Modal.Header>
          <Modal.Title>Custom Variable ({variableKey})</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Input 
                placeholder='Value' 
                value={value ?? ''}
                onChange={inputVal => onChange(variableKey, inputVal)}
                ref={inputRef}
            />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose} appearance="primary">
            Ok
          </Button>
        </Modal.Footer>
      </Modal>);
};
